package pwgs.ui.scenes.diagnosticsissuelistscene


class DiagnosticsIssueListControllerFe(props: DiagnosticsIssueListSceneProps, scene: MDiagnosticsIssueListScene) : ADiagnosticsIssueListControllerFe(props, scene) {

    override fun createInitialModel() : DiagnosticsIssueListSceneModel {
        return DiagnosticsIssueListSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }


}

